var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBenefitCardEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "295px",
    height: "306px",
    viewBox: "0 0 295 306",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CIAM-GB-member-(Mobile)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(0.000000, 47.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "field",
    stroke: "#C2C3C9",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 0.5,
    y: 14.5,
    width: 294,
    height: 173,
    rx: 16
  }), /*#__PURE__*/React.createElement("text", {
    id: 12345,
    fontFamily: "ManulifeJHSans-Demibold, Manulife JH Sans",
    fontSize: 16,
    fontWeight: 500,
    fill: "#5E6073"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 32,
    y: 127
  }, "0012345")), /*#__PURE__*/React.createElement("text", {
    id: 1,
    fontFamily: "ManulifeJHSans-Demibold, Manulife JH Sans",
    fontSize: 16,
    fontWeight: 500,
    fill: "#5E6073"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 160,
    y: 127
  }, "000000001")), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(33.000000, 38.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.245614,17.344784 L56.245614,16.2011719 C55.6929825,16.8365119 54.8333333,17.59892 53.2982456,17.59892 C51.5175439,17.59892 50.1052632,16.4553079 50.1052632,14.4857537 C50.1052632,12.0714614 52.254386,11.1819853 54.4035088,10.9913833 L55.2017544,10.9278493 C56,10.8643153 56.3070175,10.4195772 56.3070175,9.84777114 C56.3070175,9.14889706 55.6929825,8.640625 54.7105263,8.640625 C53.6052632,8.640625 52.5614035,9.4665671 52.1315789,10.1019072 L50.9035088,8.57709099 C51.7017544,7.56054687 53.0526316,6.79813879 54.8333333,6.79813879 C57.1052632,6.79813879 58.4561404,8.00528493 58.4561404,10.1019072 L58.4561404,17.471852 L56.245614,17.471852 L56.245614,17.344784 L56.245614,17.344784 Z M56.245614,12.3891314 L54.7105263,12.5797335 C53.4210526,12.7703355 52.254386,13.2150735 52.254386,14.3586857 C52.254386,15.1846278 52.9298246,15.7564338 53.7894737,15.7564338 C54.8333333,15.7564338 55.6929825,15.0575597 56.245614,14.3586857 L56.245614,12.3891314 L56.245614,12.3891314 Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6929825,17.344784 L60.4824561,17.344784 L60.4824561,6.98874081 L62.6929825,6.98874081 L62.6929825,8.13235294 C63.4912281,7.36994485 64.6578947,6.73460478 65.9473684,6.73460478 C67.1140351,6.73460478 68.7719298,7.43347886 68.7719298,9.97483915 L68.7719298,17.344784 L66.5614035,17.344784 L66.5614035,10.5466452 C66.5614035,9.5301011 66.1315789,8.640625 65.1491228,8.640625 C64.2894737,8.640625 63.245614,9.40303309 62.6929825,9.84777114 L62.6929825,17.344784 Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5701754,6.98874081 L78.7807018,6.98874081 L78.7807018,17.344784 L76.5087719,17.344784 L76.5087719,16.2011719 C75.8947368,16.7729779 74.9122807,17.535386 73.622807,17.535386 C72.3333333,17.535386 70.5526316,16.8365119 70.5526316,14.2316176 L70.5526316,6.98874081 L72.7631579,6.98874081 L72.7631579,13.5327436 C72.7631579,14.7398897 73.254386,15.5658318 74.2982456,15.5658318 C75.1578947,15.5658318 75.9561404,14.9940257 76.5701754,14.2951517 L76.5701754,6.98874081 L76.5701754,6.98874081 Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    points: "83.3859649 17.344784 81.1754386 17.344784 81.1754386 3.68497243 83.3859649 1.39774816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0087719,2.28722426 C87.745614,2.28722426 88.4210526,2.92256434 88.4210526,3.74850643 C88.4210526,4.57444853 87.745614,5.2097886 87.0087719,5.2097886 C86.2105263,5.2097886 85.5964912,4.51091452 85.5964912,3.74850643 C85.5964912,2.98609835 86.2105263,2.28722426 87.0087719,2.28722426 Z M88.1754386,17.344784 L85.9035088,17.344784 L85.9035088,6.98874081 L88.1754386,6.98874081 L88.1754386,17.344784 Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1754386,8.89476103 L93.0877193,8.89476103 L93.0877193,17.408318 L90.877193,17.408318 L90.877193,8.89476103 L89.5263158,8.89476103 L89.5263158,6.98874081 L90.877193,6.98874081 L90.877193,4.82858456 C90.877193,3.11316636 91.9210526,1.58835018 94.0087719,1.58835018 C94.9912281,1.58835018 95.7894737,1.84248621 96.2807018,2.09662224 L95.6052632,3.87557445 C95.2982456,3.68497243 94.8070175,3.4943704 94.377193,3.4943704 C93.7017544,3.4943704 93.0877193,4.00264246 93.0877193,4.95565257 L93.0877193,6.98874081 L95.7280702,6.98874081 L95.1754386,8.89476103 Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8157895,12.7703355 C97.8157895,14.4222197 98.9824561,15.6293658 100.394737,15.6293658 C101.438596,15.6293658 102.54386,14.9304917 102.973684,14.0410156 L104.385965,15.3752298 C103.587719,16.5823759 101.991228,17.59892 100.210526,17.59892 C97.3245614,17.59892 95.5438596,15.3752298 95.5438596,12.1349954 C95.5438596,9.02182904 97.4473684,6.67107077 100.27193,6.67107077 C102.912281,6.67107077 104.815789,8.45002298 104.692982,12.7068015 L97.8157895,12.7703355 L97.8157895,12.7703355 Z M102.298246,11.0549173 C102.298246,9.78423713 101.5,8.57709099 100.149123,8.57709099 C98.8596491,8.57709099 97.877193,9.84777114 97.8157895,11.0549173 L102.298246,11.0549173 Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    points: "37.4561404 17.344784 35 17.344784 35 2.92256434 37.5789474 2.92256434 41.754386 10.0383732 41.754386 10.0383732 45.8070175 2.92256434 48.3859649 2.92256434 48.3859649 17.344784 45.9298246 17.344784 45.9298246 7.17934283 45.8684211 7.17934283 41.6315789 14.4222197 37.4561404 7.17934283 37.4561404 7.17934283"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#00A758",
    points: "14.122807 3.87557445 14.122807 20.0767463 17.622807 16.4553079 17.622807 0.254136029"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#00A758",
    points: "7.18421053 20.0767463 10.6842105 16.4553079 10.6842105 0.254136029 7.18421053 3.87557445"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#00A758",
    points: "0.184210526 20.0767463 3.68421053 16.4553079 3.68421053 0.254136029 0.184210526 3.87557445"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "Plan-contract",
    fontFamily: "ManulifeJHSans-Demibold, Manulife JH Sans",
    fontSize: 12,
    fontWeight: 500,
    fill: "#8E90A2"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 33,
    y: 101
  }, "Plan contract")), /*#__PURE__*/React.createElement("text", {
    id: "Member-certificate",
    fontFamily: "ManulifeJHSans-Demibold, Manulife JH Sans",
    fontSize: 12,
    fontWeight: 500,
    fill: "#8E90A2"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 160,
    y: 101
  }, "Member certificate")), /*#__PURE__*/React.createElement("line", {
    x1: 213,
    y1: 83,
    x2: 213,
    y2: 1,
    id: "Line",
    stroke: "#00A758",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65,
    y1: 204,
    x2: 65,
    y2: 141,
    id: "Line",
    stroke: "#00A758",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Certificate-number",
    fontFamily: "ManulifeJHSans-Regular, Manulife JH Sans",
    fontSize: 16,
    fontWeight: "normal",
    fill: "#34384B"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 150,
    y: 16
  }, "Certificate number")), /*#__PURE__*/React.createElement("text", {
    id: "Plan-contract-number",
    fontFamily: "ManulifeJHSans-Regular, Manulife JH Sans",
    fontSize: 16,
    fontWeight: "normal",
    fill: "#34384B"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 26,
    y: 279
  }, "Plan contract number")), /*#__PURE__*/React.createElement("text", {
    id: "9-digits",
    fontFamily: "ManulifeJHSans-Light, Manulife JH Sans",
    fontSize: 16,
    fontWeight: 300,
    fill: "#34384B"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 150,
    y: 39
  }, "9 digits")), /*#__PURE__*/React.createElement("text", {
    id: "7-digits",
    fontFamily: "ManulifeJHSans-Light, Manulife JH Sans",
    fontSize: 16,
    fontWeight: 300,
    fill: "#34384B"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 26,
    y: 302
  }, "7 digits"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitCardEn);
export default __webpack_public_path__ + "static/media/benefitCardEN.a017fc8c291e8af6bbd8e9078c2dfb2b.svg";
export { ForwardRef as ReactComponent };